module.exports = __webpack_public_path__ + "static/media/banner001-a.96c6807e.jpg";